/* eslint no-param-reassign: 0 */
import { PaymentConsts } from 'client/util/Constants';
import OrganizationsApi from 'client/api/v2/OrganizationsApi';
import ProvidersApi from 'client/api/v2/ProvidersApi';
import Vue from 'vue';

const { responseMessages } = PaymentConsts;

const initialState = () => ({
  item: {
    productCode: '',
  },
  isProvider: false,
});

/**
 * @description The PaymentModel Vuex module provides an interface to the Billing & Payment
 * item being used in the Payment modal.
 */
export default {
  namespaced: true,

  state: initialState(),

  actions: {
    setIsProvider({ commit }, { isProvider }) {
      commit('SET_IS_PROVIDER', { isProvider });
    },

    setProductCode({ commit }, productCode) {
      commit('SET_PRODUCT_CODE', productCode);
    },

    setSubscription({ state }, id) {
      const { productCode } = state.item;
      const paymentApi = state.isProvider ? ProvidersApi : OrganizationsApi;

      return paymentApi.updatePaymentDetails(id, {
        productCode,
      })
        .catch(() => Promise.reject(responseMessages.setSubscriptionError));
    },
  },

  mutations: {
    SET_IS_PROVIDER(state = { item: {} }, { isProvider }) {
      state.isProvider = isProvider;
    },

    SET_PRODUCT_CODE(state = { item: {} }, { productCode = '' }) {
      Vue.set(state.item, 'productCode', productCode);
    },
  },
};
